/* eslint-disable consistent-return */
import React, { useMemo, useEffect, useRef } from 'react';
import { Typography, Button, Box } from '@mui/material';
import StyledBox, {
  StyledImgBox,
} from 'views/rebranded-module/common/components/UI/AppAdMobileV2/AppAdMobileV2.styles';
import { useTranslation } from 'next-i18next';
import { RiCloseFill } from 'react-icons/ri';
import { isSafari } from 'lib/utils/isSafari';
import { detectDeviceOS, osTypes } from 'lib/utils/detectDeviceOS';
import PATHS from 'lib/navigation/paths';
import {
  setLocalStorageKeyeWithTTL,
  // checkTTLExpiration,
} from 'lib/utils/localStroage';
import { useSelector } from 'react-redux';
import { Typography700 } from 'views/rebranded-module/common/components';

const logoImage = {
  src: '/imgs/Rebranding/Layout/logo_icon.svg',
  alt: 'Eaglerider Logo',
};

const AppAdMobileV2 = (props) => {
  const {
    localStorageName,
    localStorageValue,
    setAdVisible,
    isAdVisible,
    setAdHeight,
  } = props;
  const { t } = useTranslation('fe_er_common_app_ad_mobile');
  const isSafariBrowser = useMemo(() => isSafari(), []);
  const { appState } = useSelector((state) => state.globalData);
  const osType = useMemo(() => detectDeviceOS(), []);
  const adRef = useRef(null);
  const resizeObserverRef = useRef(null);

  const getStoreHref = () => {
    switch (osType) {
      case osTypes.ios:
        return PATHS.app.ios;
      case osTypes.android:
        return PATHS.app.android;
      default:
        return PATHS.app.playStore;
    }
  };
  const localStorageTtl = +(
    appState?.settings?.mobile_banner_ad_hidden_for || null
  );

  const handleCloseAdClick = () => {
    setAdVisible(false);
    setLocalStorageKeyeWithTTL(
      localStorageName,
      localStorageValue,
      localStorageTtl,
    );
    setAdVisible(false);
  };

  const handleGetBtnClick = () => {
    setLocalStorageKeyeWithTTL(
      localStorageName,
      localStorageValue,
      localStorageTtl,
    );
  };

  useEffect(() => {
    setAdVisible(!isSafariBrowser);
  }, []);
  useEffect(() => {
    if (!adRef.current) return;

    const updateHeight = () => {
      if (adRef.current) {
        setAdHeight(adRef.current.offsetHeight);
      }
    };

    // Create a ResizeObserver to track changes in the element's size
    resizeObserverRef.current = new ResizeObserver(updateHeight);
    resizeObserverRef.current.observe(adRef.current);

    // Initial height measurement
    updateHeight();

    // Cleanup function - no explicit return needed
    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, [isAdVisible, setAdHeight]);

  return (
    <StyledBox className="hidden-in-print" ref={adRef}>
      {isAdVisible && (
        <Box className="AAMContainer">
          <Box className="AAMImageText" columnSpacing="1">
            <RiCloseFill
              className="AAMClosseIcon"
              onClick={handleCloseAdClick}
            />

            <StyledImgBox image={logoImage} objectFit="contain" />
            <Box>
              <Typography700 className="AAMTitle" component="p">
                {t('common_layout_v2:app_ad_mobile.eaglerider_rentals')}
              </Typography700>
              <Typography className="AAMDesc" component="p">
                {t('common_layout_v2:app_ad_mobile.vehical_models')}
              </Typography>
            </Box>
          </Box>
          <Button
            size="small"
            href={getStoreHref()}
            variant="contained"
            color="primary"
            className="AAMGetBtn"
            disableElevation
            onClick={handleGetBtnClick}>
            {t('common_layout_v2:app_ad_mobile.get_app')}
          </Button>
        </Box>
      )}
    </StyledBox>
  );
};

export { AppAdMobileV2 };
